import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'

import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { BaseService } from './base.service'
import { ConfigService } from './config.service'
import { ApolloService } from './apollo.service'

const EMPTY_CONFIG = {
  title: 'Configurator',
  // https://stackoverflow.com/questions/9126105/blank-image-encoded-as-data-uri
  loginBackground: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  logo: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
}

const CLA_CONFIG = {
  loginBackground: '/assets/cla-utek.jpg',
  logo: '/assets/logo.png'
}

const CLA_TEST_CONFIG = {
  title: '##TEST### Configurator',
  loginBackground: '/assets/cla-utek.jpg',
  logo: '/assets/logo-test.png'
}

const SYSTEMAIR_CONFIG = {
  loginBackground: '/assets/systemair.jpg',
  logo: '/assets/logo-systemair.png'
}

@Injectable()
export class StyleService extends BaseService {

  config: any = {}
  layoutUUID: string

  loginBackground: BehaviorSubject<string> = new BehaviorSubject(EMPTY_CONFIG.loginBackground)

  constructor(
    private configServ: ConfigService,
    private apolloServ: ApolloService,
    private title : Title,
  ) {
    super();

    this.initStyles()

  }

  initStyles() {
    console.log('style service', window.location.hostname)

    this.setConfig(EMPTY_CONFIG)

    // if(/configurator.systemair.com/i.test(window.location.hostname)) {
    //   // this.config = { ...this.config, ...SYSTEMAIR_CONFIG }
    // }
    // if(/localhost/i.test(window.location.hostname) ||
    //    /configuratore-cla.com/i.test(window.location.hostname)) {
    //   this.setConfig(CLA_CONFIG)
    // }
    this.getLayoutUUID(window.location.hostname)
      .subscribe((layout: any) => {
        console.log('style service layoutUUID', layout?.uuid)
        this.layoutUUID = layout?.uuid
        if(this.layoutUUID === 'TEST') {
          this.setConfig(CLA_TEST_CONFIG)
        } else if(this.layoutUUID === 'CLA') {
          this.setConfig(CLA_CONFIG)
        } else if(this.layoutUUID === 'SYSTEMAIR') {
          this.setConfig(SYSTEMAIR_CONFIG)
        } else if(this.layoutUUID) {
          this.setConfig({
            title: layout.title,
            loginBackground: this.buildFileUrl(this.layoutUUID, 'bg'),
            logo: this.buildFileUrl(this.layoutUUID, 'logo')
          })
        }
      })
  }

  refresh() {
    this.initStyles()
  }

  getLoginBackground() {
    return this.loginBackground
  }

  getLogo() {
    return this.config.logo
  }

  setConfig(config: any) {
    this.config = { ...this.config, ...config }
    this.loginBackground.next(this.config.loginBackground)
    this.title.setTitle(this.config.title)
  }

  buildFileUrl(uuid: string, type: string) {
    return this.configServ.CONFIG.files_endpoint + '/layout/' + uuid + '/' + type
  }

  getLayoutUUID(hostname: string) {
    const query = `
      query($hostname:String!) {
        get_layout_uuid(hostname:$hostname) {
          uuid
          title
        }
      }
    `
    const variables = { hostname }
    return this.apolloServ.query(query, variables)
      .pipe(map((ret: any) => ret.data.get_layout_uuid))
  }

}
